module.exports = __webpack_public_path__ + "static/media/photographycarry04.7a2a4fd1.png";